import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const WorldToursOrders = () => import('@/pages/world-tours/orders.vue');

export default [
  {
    path: '/world-tours/orders',
    name: 'WorldToursOrders',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Заказы',
      ],
    },
    component: WorldToursOrders,
  },
  {
    path: '/world-tours/orders/:id',
    name: 'WorldToursOrdersForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Заказы',
      ],
    },
    component: WorldToursOrders,
  },
];
